import { List, Print, OutLeaving } from "../Components/index.js";

export default [
    {
        path: "/application/list",
        component: List,
        name: "application.list",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/application/create",
        component: OutLeaving,
        name: "application.create",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/application/:id/edit",
        component: List,
        name: "application.edit",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/application/:id/print",
        component: Print,
        name: "application.print",
        meta: {
            requiresAuth: true,
        },
    },
];
